import { lazy, Suspense, useEffect, useState } from "react";
import { LoadingScreen } from "@/components/common/LoadingScreen";

const HomePage = lazy(() => import("@/pages/HomePage"));
const NotFoundPage = lazy(() => import("@/pages/NotFoundPage"));

export function App() {
  const [path, setPath] = useState(window.location.pathname);

  useEffect(() => {
    const updatePath = () => setPath(window.location.pathname);
    window.addEventListener("popstate", updatePath);
    return () => window.removeEventListener("popstate", updatePath);
  }, []);

  return (
    <>
      <LoadingScreen />
      <Suspense fallback={<LoadingScreen staticFallback />}>
        {path === "/" ? <HomePage /> : <NotFoundPage />}
      </Suspense>
    </>
  );
}
